import { Component, OnInit, ViewChild, TemplateRef, Input, Output, EventEmitter } from '@angular/core';
import { IEpGridModel, EpEventService, EpGridEvent, IEpGridSelectionOptions, EpButtonStyle, IEpComponentEventArg, EpGridComponent, IEpGridState, IEPGridDataResult, } from '@epicor/kinetic';
import { BistrackConfig, CustomEvents } from 'ep-bt-controls';
import { FieldAgentClient, SupplierSearchParameters, SupplierSearchParametersSupplierType, PagingParameters, SortParametersDirection, SortParameters } from 'ep-bt-field-agent-proxy';
import { EpbtFieldAgentService } from '../../services/epbt-field-agent.service';
import { EpbtFaQuickPurchaseService } from '../../services/epbt-fa-quick-purchase.service';
import { Router } from '@angular/router';
import { Location } from '@angular/common';
import { EpbtFaSortService } from '../../services/epbt-fa-sort.service';
import { Observable } from 'rxjs';


declare var $: any;

@Component({
  // tslint:disable-next-line:component-selector
  selector: 'epbt-fa-suppliers-grid',
  templateUrl: './epbt-fa-suppliers-grid.component.html',
  styleUrls: ['./epbt-fa-suppliers-grid.component.scss']
})
export class EpbtFaSuppliersGridComponent implements OnInit {
  EpButtonStyle = EpButtonStyle;

  private _searchString: string;
  @Input('searchString') set searchString(value: string) {
    this._searchString = value;
  }
  get searchString(): string { return this._searchString; }
  @Input() customerId: number;
  @ViewChild('emailTemplate', { static: true }) emailTemplate: TemplateRef<any>;
  @ViewChild('telePhoneTemplate', { static: true }) telePhoneTemplate: TemplateRef<any>;
  @ViewChild('contactNumberTemplate', { static: true }) contactNumberTemplate: TemplateRef<any>;
  gridModel: IEpGridModel;
  pageSize = 10;

  @Output() loadingChange = new EventEmitter<boolean>();
  supplierCollection: any = [];
  totalPages = 1;
  showGrid = true;
  pageArray: Array<number> = [];
  lastPage: number;
  lastRecords: any;
  mobileData: any;
  isLastRecords = false;
  isMoreEnable = false;

  public selectedSupplierItems: any;

  constructor(private client: FieldAgentClient, private router: Router,
    private config: BistrackConfig, public epEvent: EpEventService, private fieldAgentService: EpbtFieldAgentService,
    private quickPurchaseService: EpbtFaQuickPurchaseService, private location: Location,
    private sortService: EpbtFaSortService) {
    this.epEvent.onEvents([CustomEvents.SuppliersSearch]).subscribe(event => {
      this.searchString = event.data ? event.data : '';
      this.sortService.suppliertSearchValue = this.searchString;


      this.getSuppliersBySearchString(this.searchString).subscribe(res => {
        if (res && res.lines.length == 1) {
          this.quickPurchaseService.quickPurchase.supplier = res.lines[0];
          this.router.navigate(['/home/quickpurchase']);
        } else {
          if (event.data == undefined || event.data == '') {
            if (this.quickPurchaseService.searchSuppliersString) {
              if (event.data == '') {
                this.quickPurchaseService.isSuppliersSearchMessage = true;
              }
              this.updateSuppliersGridData();
            } else if (event.data == '' && sortService.isFromSorting) {
              this.quickPurchaseService.isSuppliersSearchMessage = true;
              this.updateSuppliersGridData();
            } else {
              this.quickPurchaseService.isSuppliersSearchMessage = true;
              this.updateSuppliersGridData();
            }
          } else {
            this.quickPurchaseService.isSuppliersSearchMessage = false;
            this.updateSuppliersGridData();
          }

        }
      });
    });
  }

  ngOnInit() {
    this.fieldAgentService.getBisTrackSetting((bistrackSettings: any) => {
      this.pageSize = bistrackSettings.searchPageSize;
    });
    if (this.quickPurchaseService.searchSuppliersString) {
      this.sortService.suppliertSearchValue = this.quickPurchaseService.searchSuppliersString;
      // this.getGridData();
      this.gridModel = this.getGridModel();
    }
    else
      this.sortService.suppliertSearchValue = '';
  }

  getGridModel(): IEpGridModel {
    const selectionOptions: IEpGridSelectionOptions = {
      selectByField: 'name',
      selectedKeys: [],
    };
    const model: IEpGridModel = {
      resizable: false,
      reorderable: false,
      groupable: false,
      filterable: false,
      pageable: true,
      pageSize: this.pageSize,
      scrollable: 'scrollable',
      rowHeight: 20,
      sortable: true,
      height: this.getHeight(),
      selectionOptions: selectionOptions,
      columns: [
        { field: 'code', title: 'CODE', width: 30, hidden: false },
        { field: 'name', title: 'NAME', width: 30, hidden: false },
        { field: 'phone', title: 'TELEPHONE', width: 30, hidden: false, class: 'color-blue', cellTemplate: this.telePhoneTemplate },
        { field: 'email', title: 'EMAIL', width: 30, hidden: false, class: 'color-blue', cellTemplate: this.emailTemplate },
        { field: 'contactName', title: 'CONTACT', width: 30, hidden: false },
        { field: 'contactNumber', title: 'CONTACT NUMBER', width: 30, hidden: false, class: 'color-blue', cellTemplate: this.contactNumberTemplate },
      ],
      epOnComponentEvent: (eventArg: IEpComponentEventArg) => {
        if (eventArg.eventId == 'epOnCellClick' && eventArg.event && eventArg.event.type == 'click') {
          this.navigateBackToQuickPurchase(eventArg.event.dataItem);
        }
      },
      loader: (epGrid: EpGridComponent, state: IEpGridState) => {
        const observerResult = this.getGridModelData(epGrid, state, [], false);
        return observerResult;
      }
    };
    return model;
  }

  getHeight(): number {
    const height = parseInt($('body').height());

    if (height > 900) {
      // return 300;
      return 700;
    } else { return 440; }// return 500;
  }


  getGridData() {
    this.gridModel = this.getGridModel();
    const parms = new SupplierSearchParameters();
    parms.supplierType = SupplierSearchParametersSupplierType.StockSupplier;
    parms.paging = new PagingParameters();
    parms.paging.index = 0;
    parms.paging.count = 100; // this.pageSize;
    parms.sorting = new SortParameters();
    parms.sorting.sortColumn = this.sortService.supplierSortValue;
    parms.sorting.direction = this.sortService.supplierDirectionValue == 0 ? SortParametersDirection.Ascending : SortParametersDirection.Descending;
    parms.searchText = this._searchString;

    this.client.findSuppliers(parms).subscribe(res => {
      if (res != null) {
        this.gridModel.data = res.lines;
      }
    });
  }


  navigateBackToQuickPurchase(selectedSupplier: any) {
    this.quickPurchaseService.quickPurchase.supplier = selectedSupplier;
    this.router.navigate(['/home/quickpurchase']);
  }

  onCardClick(model) {
    this.quickPurchaseService.quickPurchase.supplier = model;
    this.router.navigate(['/home/quickpurchase']);
  }

  private getSuppliersBySearchString(search: string) {
    const parms = new SupplierSearchParameters();
    parms.supplierType = SupplierSearchParametersSupplierType.StockSupplier;
    parms.paging = new PagingParameters();
    parms.paging.index = 0;
    parms.paging.count = this.pageSize;
    parms.sorting = new SortParameters();
    parms.sorting.direction = SortParametersDirection.Ascending;
    parms.sorting.sortColumn = 'code';
    parms.searchText = search;
    return this.client.findSuppliers(parms);
  }

  getGridModelData(epGrid: EpGridComponent, state: IEpGridState, supplierList, isMobile: boolean): Observable<IEPGridDataResult> {
    const observerResult = new Observable<IEPGridDataResult>(observer => {
      if (!isMobile) {
        epGrid.model.loadingIndicator = true;
      }
      const index = state.skip + state.take;
      const pageNumber = Math.ceil(index / state.take);
      const pageIndex = this.pageArray.indexOf(pageNumber);
      if ((pageIndex >= 0 && !isMobile) || (pageNumber == this.lastPage && this.lastRecords && this.lastRecords.length > 0 && !isMobile)) {
        epGrid.model.loadingIndicator = false;
        const showoff = pageNumber == this.lastPage ? this.lastRecords : this.supplierCollection.slice(state.take * pageIndex, (state.take * pageIndex) + state.take);
        const result: IEPGridDataResult = {
          data: showoff,
          total: this.totalPages
        };
        observer.next(result);
        observer.complete();
      } else {

        const parms = new SupplierSearchParameters();
        parms.supplierType = SupplierSearchParametersSupplierType.StockSupplier;
        parms.paging = new PagingParameters();
        parms.paging.index = state.skip;
        parms.paging.count = this.pageSize;
        parms.sorting = new SortParameters();
        parms.sorting.sortColumn = this.sortService.supplierSortValue;
        parms.sorting.direction = this.sortService.supplierDirectionValue == 0 ? SortParametersDirection.Ascending : SortParametersDirection.Descending;
        parms.searchText = this._searchString;

        this.client.findSuppliers(parms).subscribe(res => {
          supplierList = res.lines;
          if (supplierList != null && supplierList != undefined && supplierList.length > 0) {
            this.totalPages = res.resultCount;
            this.lastPage = Math.ceil(this.totalPages / state.take);
            if (pageNumber != this.lastPage) {
              this.pageArray.push(pageNumber);
            }
            if (!isMobile) {
              epGrid.model.loadingIndicator = false;
            }
            if (supplierList.length < state.take) {
              this.lastRecords = supplierList;
            } else {
              this.supplierCollection = [...this.supplierCollection, ...supplierList];
            }
            if (!isMobile) {
              this.mobileData = this.supplierCollection;
              if (this.lastRecords && this.lastRecords.length > 0) {
                this.mobileData = [...this.mobileData, ...this.lastRecords];
              }
              this.isMoreEnable = this.mobileData.length == this.totalPages ? false : true;
            }
            length = this.supplierCollection.length;
            const result: IEPGridDataResult = {
              data: supplierList,
              total: this.totalPages
            };
            observer.next(result);
            observer.complete();
          } else {
            const result: IEPGridDataResult = {
              data: [],
              total: 0
            };
            observer.next(result);
            observer.complete();
            if (!isMobile) {
              epGrid.model.loadingIndicator = false;
            }
            this.isMoreEnable = false;
            this.mobileData = this.mobileData ? this.mobileData : [];
          }
        });
      }
      this.loadingChange.emit(false);
    });
    return observerResult;
  }

  getMobileData() {
    const take = this.pageSize;
    for (let i = 1; i <= this.lastPage; i++) {
      const index = this.pageArray.indexOf(i);
      if (index == -1) {
        const state: IEpGridState = {
          skip: (i - 1) * take,
          take: take
        };
        let epGrid: EpGridComponent;
        this.getGridModelData(epGrid, state, [], true).subscribe(res => {
          if (res.data && res.data.length > 0) {
            let j = 0;
            if (res.data.length == state.take) {
              res.data.forEach(element => {
                this.mobileData.splice((state.take * (i - 1)) + j, 0, element);
                j++;
              });
            }
            if (this.lastRecords && this.lastRecords.length > 0 && !this.isLastRecords) {
              this.mobileData = [...this.mobileData, ...this.lastRecords];
              this.isLastRecords = true;
            }
            this.isMoreEnable = this.mobileData.length == this.totalPages ? false : true;
          }
        });
        break;
      }
    }
  }

  updateSuppliersGridData() {
    this.lastPage = 0;
    this.lastRecords = undefined;
    this.mobileData = undefined;
    this.isLastRecords = false;
    this.pageArray.length = 0;
    this.isMoreEnable = false;
    this.gridModel = undefined;
    this.showGrid = false;
    this.supplierCollection.length = 0;
    setTimeout(() => {
      this.showGrid = true;
      this.loadingChange.emit(true);
      this.gridModel = this.getGridModel();
    }, 200);
  }
}
